<template>
  <div class="create-com-size">
    <div class="breadcrumb" style="background: #fff">页码设置</div>
    <div class="order-detail-basic">
      <el-form label-width="130px">
        <el-form-item label="页码名称:">
          <span v-if="$route.query.relation==='true'">{{pageMsg.pageName}}</span>
          <el-input v-model="pageMsg.pageName" v-if="$route.query.relation==='false'" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="页码起始页:">
          <span v-if="$route.query.relation==='true'">{{pageMsg.startPage}}</span>
          <el-input v-model="pageMsg.startPage" v-if="$route.query.relation==='false'" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="每p页码数:">
          <span v-if="$route.query.relation==='true'">{{pageMsg.pageNumber}}</span>
          <el-select v-model="pageMsg.pageNumber" @change="change" v-if="$route.query.relation==='false'" placeholder="请选择">
            <el-option label="1" :value="1"></el-option>
            <el-option label="2" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页码参数:">
          <p style="margin-bottom:10px" v-for="(item,index) in pageMsg.pageNumberDetailList" :key="index">
            <span>页码{{index+1}}参数: </span>
            <el-input style="width:200px" placeholder="" v-model="pageMsg.pageNumberDetailList[index].portraitParam">
              <template slot="prepend" style="width:60px">
                <el-select v-model="pageMsg.pageNumberDetailList[index].portrait" style="width:60px;overflow:hidden" placeholder="选择">
                  <el-option label="距上" value="top"></el-option>
                  <el-option label="距下" value="bottom"></el-option>
                </el-select>
              </template>
              <template slot="append">mm</template>
            </el-input>
            <el-input style="width:200px" placeholder="" v-model="pageMsg.pageNumberDetailList[index].transverseParam">
              <template slot="prepend">
                <el-select v-model="pageMsg.pageNumberDetailList[index].transverse" style="width:60px;overflow:hidden" placeholder="选择">
                  <el-option label="距左" value="left"></el-option>
                  <el-option label="距右" value="right"></el-option>
                </el-select>
              </template>
              <template slot="append">mm</template>
            </el-input>
          </p>
        </el-form-item>
        <el-form-item label="页码样式:" prop="typeId">
          <el-select v-model="pageMsg.typeId" placeholder="请选择" @change="chagneType">
            <el-option v-for="item in styleList" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预览:">
          <span :style="'font-size:'+pageMsg.fontSize+'px'">{{preview}}</span>
        </el-form-item>
        <el-form-item label="字号:" prop="fontSize">
          <el-input v-model.number="pageMsg.fontSize" placeholder="请输入字号"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>
 <script>
import { pageNumberUpdate, pageNumberQueryPageNumberById, getPageNumberTypeList } from '@/api/pms'
export default {
  name: 'create-com-size',
  data () {
    return {
      pageMsg: {},
      styleList: [],
      preview: ''
    }
  },
  created () {
    this.onSubmit()
    this.getStyleList()
  },
  methods: {
    chagneType (val) {
      this.preview = this.styleList.filter(item => item.id === val)[0].preview
    },
    getStyleList () {
      getPageNumberTypeList().then(res => {
        if (res.data.success) {
          this.styleList = res.data.data
        }
      })
    },
    change (val) {
      if (val === 2) {
        this.pageMsg.pageNumberDetailList.push({
          // id: 0,
          portrait: '',
          portraitParam: '',
          sorting: 1,
          transverse: '',
          transverseParam: ''
        })
      } else if (val === 1) {
        this.pageMsg.pageNumberDetailList.pop()
      }
    },
    save () {
      if (this.pageMsg.pageName === '') {
        this.$message.error('请输入页码名称')
        return
      }
      let lock = false
      let dataLock = false
      this.pageMsg.pageNumberDetailList.forEach(item => {
        if (item.portraitParam === '' || item.transverseParam === '' || item.portrait === '' || item.transverse === '') {
          lock = true
        }
        if (!/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(item.transverseParam) || !/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(item.portraitParam)) {
          dataLock = true
        }
      })
      if (lock) {
        this.$message.error('页码参数不全')
        return
      } else if (dataLock) {
        this.$message.error('页码参数为0或正数')
        return
      }
      let updatePageVo = {
        detailVoList: JSON.parse(JSON.stringify(this.pageMsg.pageNumberDetailList)),
        id: this.pageMsg.id,
        pageName: this.pageMsg.pageName,
        fontSize: this.pageMsg.fontSize,
        typeId: this.pageMsg.typeId,
        pageNumber: this.pageMsg.pageNumber,
        startPage: this.pageMsg.startPage
      }
      pageNumberUpdate(updatePageVo).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功')
          this.$router.go(-1)
        }
      })
    },
    onSubmit () {
      pageNumberQueryPageNumberById(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.pageMsg = res.data.data
          this.preview = res.data.data.pageNumberType.preview
        }
      })
    }
  }
}
</script>
 <style scoped lang="less">
@deep: ~">>>";
.create-com-size {
  .spec-mm {
    span {
      margin-right: 10px;
    }
    .el-input {
      width: auto;
      @{deep} .el-input__inner {
        width: 65px;
      }
    }
    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }
}
</style>
